"use client";

import * as React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Is this just another wellbeing survey?",
  answer: "No, this is a comprehensive assessment designed to identify specific actionable areas rather than just measuring general sentiment. It provides deep insights into organizational health."
}, {
  question: "Who is it for?",
  answer: "It is designed for organizations of all sizes looking to proactively manage and improve employee wellbeing, reduce burnout risks, and foster a healthier workplace culture."
}, {
  question: "Does it replace a full legal stress risk assessment?",
  answer: "While it provides valuable insights and covers many key areas, it is designed to complement rather than entirely replace formal legal compliance assessments depending on your specific local jurisdiction requirements."
}, {
  question: "Can results be broken down by team/department?",
  answer: "Yes, the reporting dashboard allows you to filter and analyze results by various demographic cuts including team, department, and location, provided minimum group sizes are met to protect anonymity."
}, {
  question: "Will employees be identifiable?",
  answer: "No, all responses are strictly confidential. Data is aggregated and we enforce minimum reporting thresholds to ensure individual anonymity is maintained at all times."
}, {
  question: "What happens after the survey?",
  answer: "You receive a detailed report with actionable recommendations. Our team will walk you through the findings and help you prioritize the most impactful interventions for your organization."
}, {
  question: "Can Feel Good Works help after the report?",
  answer: "Absolutely. We offer a range of follow-up services, targeted workshops, and ongoing consulting to help you address the specific needs and risks identified in your report."
}, {
  question: "How quickly can it be deployed?",
  answer: "The assessment can typically be customized, communicated, and deployed to your organization within 1-2 weeks from our initial consultation and agreement."
}];
export default function FaqsAccordion() {
  return <section id="faqs-accordion" className="w-full bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-3xl px-4 md:px-6">
        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border/60 py-2">
              <AccordionTrigger className="group py-4 hover:no-underline [&>svg]:hidden">
                <div className="flex w-full items-center justify-between gap-6 text-left">
                  <span className="font-default text-[20px] font-bold text-chart-5">
                    {faq.question}
                  </span>
                  <div className="shrink-0 rounded-full p-1 transition-colors group-hover:bg-muted/50">
                    <Plus className="size-[18px] text-chart-2 transition-transform duration-300 group-data-[state=open]:rotate-45" />
                  </div>
                </div>
              </AccordionTrigger>
              <AccordionContent>
                <p className="pt-2 pb-4 pr-8 text-[17px] leading-relaxed text-foreground">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}